import {
  READ_EDUCATIONS_LIST,
  READ_EMPLOYEE_ACCOUNTS_1C_ID,
  READ_EMPLOYEE_ACCOUNTS_AZURE_ID,
  READ_EMPLOYEE_CONTACT_INFORMATION,
  READ_EMPLOYEE_FAMILY_INFORMATION,
  READ_EMPLOYEE_IDENTITY_DOCUMENTS,
  READ_EMPLOYEE_MAIN_PERSONAL_INFO,
  EMPLOYEE_TYPES_ALIAS,
} from 'domain/shared/employee';
import { READ_BACKGROUND_CHECK_LIST } from './backgroundcheck/shared/employeeBackgroundCheckService';
import { Box, styled } from '@mui/material';
import { EmployeeFamilySummary } from './family';
import EmployeeHigherEducationSummary from './education/show/EmployeeHigherEducationSummary';
import { EmployeeBackgroundCheckSummary } from './backgroundcheck';
import { EmployeeAccountsSummary } from './accounts';
import { EmployeeContactInfoSummary } from './contactinfo';
import { EmployeeIdentityDocumentsSummary } from './identitydocuments';
import { EmployeePersonalInfoSummary } from './personalinfo';
import EmployeeSectionWrapper from '../shared/EmployeeSectionWrapper';
import { EmployeeRequisitesSummary } from './requisites';
import { useShowContext } from 'framework/show';

const EmployeeGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '0.4fr 0.6fr',
  columnGap: '16px',
  alignItems: 'start',
  width: '100%',
  position: 'relative',

  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
})) as typeof Box;

const PersonalLegalPage = () => {
  const { data: employee } = useShowContext();
  const isContractor = employee?.getValueBySource('employeeType') === EMPLOYEE_TYPES_ALIAS.CONTRACTOR;
  return (
    <>
      <EmployeeSectionWrapper permissions={READ_EMPLOYEE_MAIN_PERSONAL_INFO} withMinHeight={false}>
        <EmployeePersonalInfoSummary />
      </EmployeeSectionWrapper>

      <EmployeeGrid>
        <EmployeeSectionWrapper permissions={READ_EMPLOYEE_IDENTITY_DOCUMENTS} withMinHeight={false} fullHeight>
          <EmployeeIdentityDocumentsSummary />
        </EmployeeSectionWrapper>

        <EmployeeSectionWrapper permissions={READ_EMPLOYEE_CONTACT_INFORMATION} withMinHeight={false} fullHeight>
          <EmployeeContactInfoSummary />
        </EmployeeSectionWrapper>
      </EmployeeGrid>

      <EmployeeGrid>
        <EmployeeSectionWrapper permissions={READ_BACKGROUND_CHECK_LIST} withMinHeight={false} fullHeight>
          <EmployeeBackgroundCheckSummary />
        </EmployeeSectionWrapper>

        <EmployeeSectionWrapper
          permissions={[READ_EMPLOYEE_ACCOUNTS_AZURE_ID, READ_EMPLOYEE_ACCOUNTS_1C_ID]}
          withMinHeight={false}
          fullHeight
        >
          <EmployeeAccountsSummary />
        </EmployeeSectionWrapper>
      </EmployeeGrid>

      <EmployeeGrid>
        <EmployeeSectionWrapper permissions={READ_EMPLOYEE_FAMILY_INFORMATION} withMinHeight={false} fullHeight>
          <EmployeeFamilySummary />
        </EmployeeSectionWrapper>

        <EmployeeSectionWrapper permissions={READ_EDUCATIONS_LIST} withMinHeight={false} fullHeight>
          <EmployeeHigherEducationSummary />
        </EmployeeSectionWrapper>
        {isContractor && (
          <EmployeeSectionWrapper permissions={READ_EMPLOYEE_MAIN_PERSONAL_INFO} withMinHeight={false} fullHeight>
            <EmployeeRequisitesSummary />
          </EmployeeSectionWrapper>
        )}
      </EmployeeGrid>
    </>
  );
};

export default PersonalLegalPage;
